import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class FilingCommunicationService {
  private reloadProcessedSource = new Subject<void>();

  reloadProcessed$ = this.reloadProcessedSource.asObservable();

  triggerReloadProcessed() {
    this.reloadProcessedSource.next();
  }
}
